module.exports = __webpack_public_path__ + "static/img/icon_3_mk.af829036.svg";